import { render, staticRenderFns } from "./BarOrderPanel.vue?vue&type=template&id=37091bb5&scoped=true&"
import script from "./BarOrderPanel.vue?vue&type=script&lang=js&"
export * from "./BarOrderPanel.vue?vue&type=script&lang=js&"
import style0 from "./BarOrderPanel.vue?vue&type=style&index=0&id=37091bb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37091bb5",
  null
  
)

export default component.exports